export default __webpack_public_path__ + "static/media/scottishFold.2c22cea6.png";